(() => {
  const SELECTOR = [
    'main .heading.title-md',
    'main .heading.title-lg',
    'main .heading.title-xl',
    'main .heading[class*="title-md"]',
    'main .heading[class*="title-lg"]',
    'main .heading[class*="title-xl"]',
    'main .banner__title',
    'main .category-gateway__heading',
    'main .collaboration-orbit__copy > .heading',
    'main .product__title > .heading'
  ].join(',');

  const EXCLUDED_CONTEXT = [
    '.product-card',
    '.collection-card',
    '.media-card',
    '.horizontal-product',
    '.accordion',
    '.details',
    '.drawer',
    '.modal',
    '.predictive-search',
    '.header-section',
    '.footer-group',
    'form'
  ].join(',');

  const ACTIVE_CLASS = 'is-liquid-active';
  const READY_CLASS = 'privado-liquid-heading';
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  const cleanText = (value) => value.replace(/\s+/g, ' ').trim();

  const shouldEnhance = (element) => {
    if (!element || element.dataset.privadoLiquidHeading === 'true') return false;
    if (element.closest(EXCLUDED_CONTEXT)) return false;
    if (element.querySelector('a, button, input, select, textarea')) return false;

    const text = cleanText(element.textContent || '');
    return text.length > 3;
  };

  const assignIndexes = (element) => {
    const chars = element.querySelectorAll('.char, .privado-liquid-char');
    chars.forEach((char, index) => {
      char.style.setProperty('--liquid-i', index % 34);
      char.setAttribute('aria-hidden', 'true');
    });
  };

  // Split into WORDS first (each word is an inline-block wrapper that never
  // breaks across lines), with per-char spans inside for the liquid animation.
  // Whitespace stays as plain text so wrapping only ever happens BETWEEN words —
  // a word like "by" can never split into "b"/"y".
  const splitFallback = (element) => {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        return cleanText(node.nodeValue || '')
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    });
    const nodes = [];
    let node = walker.nextNode();

    while (node) {
      nodes.push(node);
      node = walker.nextNode();
    }

    nodes.forEach((textNode) => {
      const fragment = document.createDocumentFragment();
      const parts = (textNode.nodeValue || '').split(/(\s+)/);

      parts.forEach((part) => {
        if (part === '') return;

        if (/^\s+$/.test(part)) {
          fragment.appendChild(document.createTextNode(part));
          return;
        }

        const word = document.createElement('span');
        word.className = 'privado-liquid-word';

        Array.from(part).forEach((char) => {
          const span = document.createElement('span');
          span.className = 'privado-liquid-char';
          span.textContent = char;
          word.appendChild(span);
        });

        fragment.appendChild(word);
      });

      textNode.replaceWith(fragment);
    });
  };

  // Always use the word-aware fallback so wrapping is word-level regardless of
  // whether the Splitting library is present (its char mode breaks mid-word).
  const splitHeading = (element) => {
    if (element.querySelector('.privado-liquid-word, .char, .privado-liquid-char')) return;
    splitFallback(element);
  };

  const bindPulse = (element) => {
    let timeout;

    const pulse = () => {
      if (REDUCED_MOTION.matches) return;

      window.clearTimeout(timeout);
      element.classList.remove(ACTIVE_CLASS);
      element.offsetWidth;
      element.classList.add(ACTIVE_CLASS);

      timeout = window.setTimeout(() => {
        element.classList.remove(ACTIVE_CLASS);
      }, 560);
    };

    element.addEventListener('pointerdown', pulse, { passive: true });
    element.addEventListener('click', pulse, { passive: true });
  };

  const enhance = (element) => {
    if (!shouldEnhance(element)) return;

    const label = cleanText(element.textContent || '');
    element.dataset.privadoLiquidHeading = 'true';
    element.classList.add(READY_CLASS);
    element.setAttribute('aria-label', label);

    splitHeading(element);
    assignIndexes(element);
    bindPulse(element);
  };

  const init = (root = document) => {
    window.requestAnimationFrame(() => {
      root.querySelectorAll(SELECTOR).forEach(enhance);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  }
  else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('page:loaded', () => init());
})();
